/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {Subject} from 'rxjs/Subject';

import {Comparator} from '../interfaces/comparator';
import {StateDebouncer} from './state-debouncer.provider';
export class Sort {
/**
 * @param {?} stateDebouncer
 */
constructor(private stateDebouncer: StateDebouncer) {}
/**
 * Currently active comparator
 */
private _comparator: Comparator<any>;
/**
 * @return {?}
 */
public get comparator(): Comparator<any> {
        return this._comparator;
    }
/**
 * @param {?} value
 * @return {?}
 */
public set comparator(value: Comparator<any>) {
        this.stateDebouncer.changeStart();
        this._comparator = value;
        this.emitChange();
        this.stateDebouncer.changeDone();
    }
/**
 * Ascending order if false, descending if true
 */
private _reverse: boolean = false;
/**
 * @return {?}
 */
public get reverse(): boolean {
        return this._reverse;
    }
/**
 * @param {?} value
 * @return {?}
 */
public set reverse(value: boolean) {
        this.stateDebouncer.changeStart();
        this._reverse = value;
        this.emitChange();
        this.stateDebouncer.changeDone();
    }
/**
 * The Observable that lets other classes subscribe to sort changes
 */
private _change = new Subject<Sort>();
/**
 * @return {?}
 */
private emitChange() {
        this._change.next(this);
    }
/**
 * @return {?}
 */
public get change(): Observable<Sort> {
        return this._change.asObservable();
    }
/**
 * Sets a comparator as the current one, or toggles reverse if the comparator is already used. The
 * optional forceReverse input parameter allows to override that toggling behavior by sorting in
 * reverse order if `true`.
 * 
 * 
 * \@memberof Sort
 * @param {?} sortBy
 * @param {?=} forceReverse
 * @return {?}
 */
public toggle(sortBy: Comparator<any>, forceReverse?: boolean) {
        this.stateDebouncer.changeStart();
        // We modify private properties directly, to batch the change event
        if (this.comparator === sortBy) {
            this._reverse = typeof forceReverse !== "undefined" ? forceReverse || !this._reverse : !this._reverse;
        } else {
            this._comparator = sortBy;
            this._reverse = typeof forceReverse !== "undefined" ? forceReverse : false;
        }
        this.emitChange();
        this.stateDebouncer.changeDone();
    }
/**
 * Clears the current sorting order
 * @return {?}
 */
public clear() {
        this.comparator = null;
    }
/**
 * Compares two objects according to the current comparator
 * @param {?} a
 * @param {?} b
 * @return {?}
 */
public compare(a: any, b: any): number {
        return (this.reverse ? -1 : 1) * this.comparator.compare(a, b);
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: StateDebouncer, },
];
}

function Sort_tsickle_Closure_declarations() {
/** @type {?} */
Sort.decorators;
/**
 * @nocollapse
 * @type {?}
 */
Sort.ctorParameters;
/**
 * Currently active comparator
 * @type {?}
 */
Sort.prototype._comparator;
/**
 * Ascending order if false, descending if true
 * @type {?}
 */
Sort.prototype._reverse;
/**
 * The Observable that lets other classes subscribe to sort changes
 * @type {?}
 */
Sort.prototype._change;
/** @type {?} */
Sort.prototype.stateDebouncer;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
